export default "__VITE_ASSET__CiXese1s__"